import React, { useEffect } from "react";
import { Button, Flex, Form, Input, Modal } from "antd";
import { useFetch } from "../../Services/useFetch";
import { toast } from "react-toastify";

const RenameDocument = (props) => {
  const {
    open,
    setOpen,
    renameKeys,
    loadings,
    fetchBriefFolderList,
    handleLoading,
    currentFolderKey,
    renameFolder,
    userInfo,
    socket,
  } = props;

  const { request } = useFetch();
  const notify = (error) => toast.error(error);
  const notifySuccess = (msg) => toast.success(msg);

  const handleTrimStart = (name, e) => {
    const inputValue = e.target.value;
    const sanitizedValue = inputValue.replace(
      /[^a-zA-Z0-9\s._\-@(){}\[\],&+=]/g,
      ""
    );

    renameFolder.setFieldsValue({ [name]: sanitizedValue.trimStart() });
    const inputElement = e.target;
    const caretPosition =
      inputElement.selectionStart - (inputValue.length - sanitizedValue.length);
    inputElement.setSelectionRange(caretPosition, caretPosition);
  };
  const renameFolderFun = async (item) => {
    handleLoading("loadingFolder", true);
    const formData = new URLSearchParams();
    if (renameKeys == "folder") {
      formData.append("folder_id", currentFolderKey?.key);
      formData.append("folder_name", item?.folder_name);
    }
    if (renameKeys == "file") {
      formData.append("file_id", currentFolderKey?.key);
      formData.append("document_title", item?.folder_name);
    }
    try {
        const response = await request("/rename-folder-file", "put", formData, {
          "Content-Type": "application/x-www-form-urlencoded",
        });

      if (response?.data?.status === "1") {

        fetchBriefFolderList(currentFolderKey?.parent_id);
        setOpen(false);
        renameFolder.resetFields();
        handleLoading("loadingFolder", false);
        notifySuccess("Folder Name Changed Successfully");
        socket.emit("directory-action", {
          userName: userInfo?.userfullname,
          action: "Rename",
        });
      } else {
        notify("Folder with this name is Already Exist");
        handleLoading("loadingFolder", false);
      }
    } catch (error) {
      console.log("error", error);
      handleLoading("loadingFolder", false);
    }
  };

  useEffect(() => {
    socket.on("directory-action", ({ userName, action }) => {
      // notifySuccess(`${userName} has ${action} a directory.`);
    });

    return () => {
      socket.off("directory-action");
    };
  }, []);

  return (
    <>
      <Modal
        title={renameKeys == "folder" ? " Rename Folder" : "Rename File"}
        open={open}
        className="bd_model_main shareModal"
        onCancel={() => {
          setOpen(false);
          renameFolder.resetFields();
        }}
        footer={null}
      >
        <Form
          name="validateOnly"
          layout="vertical"
          autoComplete="off"
          form={renameFolder}
          onFinish={(val) => renameFolderFun(val)}
        >
          <div className="bd_model_input">
            <Form.Item
              label={renameKeys == "folder" ? "Folder Name" : "File Name"}
              name="folder_name"
              rules={[
                {
                  required: true,
                  message:
                    renameKeys === "folder"
                      ? "Folder name is required"
                      : "File name is required",
                },
              ]}
            >
              <Input
                placeholder="Enter here"
                onChange={(e) => handleTrimStart("folder_name", e)}
              />
            </Form.Item>
          </div>

          <Flex justify="flex-end" align="center">
            <Button
              key="back"
              className="BG_ghostButton"
              onClick={() => renameFolder.resetFields()}
            >
              Reset
            </Button>
            <Button
              key="submit"
              className="BG_mainButton"
              style={{ marginLeft: "20px" }}
              type="primary"
              htmlType="submit"
              loading={loadings?.loadingFolder}
              disabled={loadings?.loadingFolder}
            >
              Submit
            </Button>
          </Flex>
        </Form>
      </Modal>
    </>
  );
};

export default RenameDocument;
